import { chainReducers, createApiReducer, INITIAL_API_STATUS } from "services/api";
import { TranslationActionTypes } from "./actions";
import { transformTranslationRow } from "../transformation";

const initialState = {
  _status: INITIAL_API_STATUS,
  items: [],
};

const fetchTranslationReducer = createApiReducer(
  [
    TranslationActionTypes.FETCH_TRANSLATIONS_START,
    TranslationActionTypes.FETCH_TRANSLATIONS_SUCCESS,
    TranslationActionTypes.FETCH_TRANSLATIONS_FAILURE,
  ],
  (data) => {
    return {
      items: data.results.map(transformTranslationRow),
    };
  },
  (data) => {
    return data;
  }
);


const deleteTranslationReducer = createApiReducer(
  [
    TranslationActionTypes.DELETE_TRANSLATIONS_START,
    TranslationActionTypes.DELETE_TRANSLATIONS_SUCCESS,
    TranslationActionTypes.DELETE_TRANSLATIONS_FAILURE,
  ],
  (data, state) => {
    return {
      ...state,
      items: state.items.filter((i: any) => i.id !== data.translationId),
    };
  },
  data => data
);



const settingsTranslationChainedReducers = chainReducers(
  initialState,
  fetchTranslationReducer,
  deleteTranslationReducer
);

export default settingsTranslationChainedReducers;


